export default __webpack_public_path__ + "static/media/management-accelerator-pathway.98002a2a.svg";